module.exports = __webpack_public_path__ + "img/b6c5b76.jpg";